import gql from 'graphql-tag';

const CREATE_NON_MONITORED_ASSET = gql`
  mutation($input: NonMonitoredAssetClassInput) {
    createNonMonitoredAssetClass(input: $input) {
      classId
      name
      lastUpdatedTime
      entityName
      customFields {
        id
        label
        fieldType
        options
      }
    }
  }
`;

const CREATE_ASSET_CLASS = gql`
  mutation($input: CreateAssetClassInput) {
    createAssetClass(input: $input) {
      classId
      name
      lastUpdatedTime
      entityName
      customFields {
        id
        label
        fieldType
        options
      }
    }
  }
`;

const GET_ASSET_DEFAULT_FIELDS = gql`
  query($moduleType: String) {
    getAssetClassDefaultFields(moduleType: $moduleType)
  }
`;

const GET_ASSET_CLASS = gql`
  query($classId: ID!) {
    getAssetClass(classId: $classId) {
      classId
      name
      lastUpdatedTime
      description
      formMeta
      iconClass
      isNonMonitored
      moduleType
      supportedModules
      metrics {
        metricId
        name
        description
        pollInterval
        state
        category
      }
      associatedFields {
        id
        label
        fieldType
        options {
          id
          value
          order
        }
        description
        commonWorkStationField
      }
      customFields {
        id
        label
        fieldType
        options
        description
        commonWorkStationField
      }
      isSystemGenerated
      assetDefaultFields
      fieldEntity {
        entityId
        name
      }
    }
  }
`;

const UPDATE_NON_MONITORED_ASSET = gql`
  mutation($classId: ID!, $input: NonMonitoredAssetClassInput) {
    updateAssetClass(classId: $classId, input: $input) {
      classId
      name
      lastUpdatedTime
      entityName
      customFields {
        id
        label
        fieldType
        options
        commonWorkStationField
      }
    }
  }
`;

const DELETE_NON_MONITORED_ASSET = gql`
  mutation($classId: ID!) {
    deleteNonMonitoredAssetClass(classId: $classId)
  }
`;

const GET_ALERT_RULE_META_INFO = gql`
  query($classId: ID!) {
    getAlertRuleMetaInfo(classId: $classId)
  }
`;

const GET_DEFAULT_ASSET_FIELDS = gql`
  query($classId: ID!) {
    getAssetDefaultFieldsForForm(classId: $classId)
  }
`;

const GET_CUSTOM_ASSET_FIELDS = gql`
  query($classId: ID!) {
    getCustomFieldsForAlertConditions(classId: $classId) {
      id
      label
      module
      options
      fieldType
      columnName
      description
      showToClient
    }
  }
`;

const GET_CUSTOM_ASSET_FIELDS_OPERATORSMAP = gql`
  query {
    getOperatorsMapForCustomFieldAlertPolicy
  }
`;

const GET_ASSET_INTEGRATION_INSTALL_STATUSES = gql`
  query($assetId: ID!) {
    getAssetIntegrationInstallStatuses(assetId: $assetId)
  }
`;

const GET_ASSET_INTEGRATION_TROUBLESHOOT_DETAILS = gql`
  query($assetId: ID!, $integrationType: String!) {
    getAssetTroubleShootDetails(
      assetId: $assetId
      integrationType: $integrationType
    ) {
      assetId
      statusByStage {
        stageId
        isSuccess
        isActionUnderProgress
        errorDetails {
          statusCode
          heading
          error
          description
          actions
        }
      }
    }
  }
`;

const GET_ASSET_INTEGRATION_TROUBLESHOOT_DETAILS_V2 = gql`
  query($assetId: ID!, $integrationType: String!) {
    getAssetTroubleShootDetailsV2(
      assetId: $assetId
      integrationType: $integrationType
    ) {
      assetId
      title
      statusByStage {
        stageId
        isSuccess
        isActionUnderProgress
        successMessage
        helpDocLink
        heading
        stageActions
        errorDetails {
          statusCode
          error
          description
        }
      }
    }
  }
`;

const GET_ASSET_CLASS_LIST_V2 = gql`
  query($moduleType: [String]) {
    getAssetClassListV2(moduleType: $moduleType) {
      classId
      name
      lastUpdatedTime
      entityName
      isNonMonitored
      isSystemGenerated
      iconClass
      isGated
      status
      moduleType
    }
  }
`;

export {
  CREATE_NON_MONITORED_ASSET,
  GET_ASSET_CLASS,
  UPDATE_NON_MONITORED_ASSET,
  DELETE_NON_MONITORED_ASSET,
  GET_ALERT_RULE_META_INFO,
  GET_DEFAULT_ASSET_FIELDS,
  GET_CUSTOM_ASSET_FIELDS,
  GET_CUSTOM_ASSET_FIELDS_OPERATORSMAP,
  GET_ASSET_INTEGRATION_INSTALL_STATUSES,
  GET_ASSET_INTEGRATION_TROUBLESHOOT_DETAILS,
  GET_ASSET_CLASS_LIST_V2,
  GET_ASSET_INTEGRATION_TROUBLESHOOT_DETAILS_V2,
  CREATE_ASSET_CLASS,
  GET_ASSET_DEFAULT_FIELDS
};
